import React, { useEffect, useState } from 'react';
import { addSpace } from '../../components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function BilanEvolDepEnergie(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {

        var filename = "Évolution des dépenses d\'énergie et d'alimentation";
        if (props.user.nomen === 'M4' || props.user.nomen === 'M41' || props.user.nomen === 'M43' || props.user.nomen === 'M49') {
            filename = "Évolution des dépenses d\'énergie et de carburants";
        }

        var ComEpci = null;
        if (props.user.id_organisme_type === '1') {
            ComEpci = 'Com';
        }
        else if (props.user.id_organisme_type === '2') {
            ComEpci = 'Epci';
        }
        else if (props.user.id_organisme_type === '3') {
            ComEpci = 'Com';
        }

        /* Initialisation des options avec les années */
        var option_tmp = {
            chart: {
                toolbar: {
                    show: props.download?true:false,
                    export: {
                        svg: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        png: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        csv: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                    },
                },
                type: 'line',
                height: 350
            },
            stroke: {
              curve: 'smooth'
            },
            title: {
                text: filename
            },
            xaxis: {
                categories: props.annees
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return addSpace(Math.round(value*100)/100, true) + " €";
                  }
                },
            },
            dataLabels: {
                formatter: (val) => {
                    return addSpace(val)+" K";
                }
            },
        }
        setOptions(option_tmp)

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
        	'evolDepEnergie': true,
            'ComEpci': ComEpci,
            'id_budget': props.user.id_budget,
            'annees': props.annees,
            'hypothese': 'R',
            'ba': props.user.budget_annexe,
            'nomen': props.user.nomen
        }))
        .then(async (res) => {
            if (props.user.nomen === 'M14' || props.user.nomen === 'M57') {
                await setSeries([{
                    name: "Énergie - Électricité",
                    data: res.data[0],
                    color: '#f9ca24',
                },{
                    name: "Chauffage urbain",
                    data: res.data[1],
                    color: '#6ab04c',
                },{
                    name: "Combustibles",
                    data: res.data[2],
                    color: '#eb4d4b',
                },{
                    name: "Carburants",
                    data: res.data[3],
                    color: '#30336b',
                },{
                    name: "Alimentation",
                    data: res.data[4],
                    color: '#3498db',
                }])
            }
            else if (props.user.nomen === 'M4' || props.user.nomen === 'M41' || props.user.nomen === 'M43' || props.user.nomen === 'M49') {
                await setSeries([{
                    name: "Fournitures non stockables (eau, énergie...)",
                    data: res.data[0],
                    color: '#f9ca24',
                },{
                    name: "Carburants",
                    data: res.data[1],
                    color: '#6ab04c',
                }])
            }
        })
    }, [])


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:400}
                type="line"
            />:null}
		</div>
	)
}

export default BilanEvolDepEnergie;
